import members from './members.json';

export const HOST = {
  PROFILE: 'https://slvn-cdn.surge.sh/profile/' as const,
  DEEPLINK: 'https://slvn.page.link/' as const,
};

export const MEMBER = members;
